import * as actionTypes from './actionTypes';

export const mapPositionsNextStep = () => {
  return {
    type : actionTypes.MAP_POSITIONS_NEXT_STEP,
    val : null
  }
}

export const mapPositionsGoBack = () => {
  return {
    type : actionTypes.MAP_POSITIONS_PREVIOUS_STEP,
    val : null
  }
}

export const mapPositionsUploadFileSuccess = (columns, data, file) => {
  return {
    type : actionTypes.MAP_POSITIONS_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapPositionsMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_POSITIONS_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllPositionsMapping = (occupation,seniority) => {
  return {
    type : actionTypes.MAP_POSITIONS_SAVE_POSITIONS_MAPPING,
    val : {
      occupations : occupation,
      seniority : seniority
    }
  }
}

export const resetPositions = () => {
  return {
    type : actionTypes.MAP_POSITIONS_RESET,
    val : null
  }
}

export const resetMapPositionsStep = () => {
  return {
    type : actionTypes.MAP_POSITIONS_RESET_STEP,
    val : null
  }
}
